import { useCallback, useState } from 'react';
import { ContractService } from '../../services/contract/contractService';
import { ProductService } from "../../services/product/productService";

/*----------------------------------------------------------------------------------------------------
* EN: Hook to manage product fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de productos.
----------------------------------------------------------------------------------------------------*/
const useProducts = (initialFilters: any = {}) => {

    const [data, setData] = useState<any[]>([]);
    const filters = {
        limit: 200,
        filter_filters: { ...initialFilters }
    };

    const fetchProducts = useCallback(async (f?: any) => {
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        try {
            const response = await (new ProductService()).listProductsForSelect(newFilters);
            const fetchedData = response.getResponseData();

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; amount: number, code: string; productTypeId?: string; productTypeName?: string; }) => ({
                    value: data.id,
                    label: `${data.code ? data.code + ' - ' : ''}${data.name}${data.productTypeName ? ` (${data.productTypeName})` : ''}`,
                    amount: data.amount,
                    name: data.name,
                    code: data.code,
                    productTypeId: data.productTypeId,
                    productTypeName: data.productTypeName
                })).filter((item: any) => item.value !== filters.filter_filters.product); // Filter by product if specified
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching products:', error);
        }
    }, []);

    const getProductsList = () => {
        return data;
    };

    return { fetchProducts, getProductsList };
}

export default useProducts;


/*----------------------------------------------------------------------------------------
* EN: Hook to manage product fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de productos.
----------------------------------------------------------------------------------------*/
export const useFindProducts = (initialFilters: any = {}) => {

    const [data, setData] = useState<any[]>([]);
    const filters = {
        limit: 200,
        filter_filters: { ...initialFilters }
    };

    const findProducts = useCallback(async (f?: any) => {
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        try {
            const response = await (new ContractService()).findProductsOnContract(newFilters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData) {
                const mappedData = fetchedData?.map((data: any) => ({
                    value: data.id,
                    label: data.name,
                    code: data.code,
                    amount: data.amount,
                    studentFieldsRequired: data.studentFieldsRequired ?? data.student_fields_required ?? false,
                    consultancyFieldsRequired: data.consultancyFieldsRequired ?? data.consultancy_fields_required ?? false,
                    productTypeConsultancyFieldsRequired: data.productTypeConsultancyFieldsRequired ?? data.product_type_consultancy_fields_required ?? data.productType?.consultancyFieldsRequired ?? data.productType?.consultancy_fields_required ?? false,
                    workersRangePriceEnabled: data.workersRangePriceEnabled ?? data.workers_range_price_enabled ?? false,
                    workersRangeExtraPriceEnabled: data.workersRangeExtraPriceEnabled ?? data.workers_range_extra_price_enabled ?? false,
                    workersRangeExtraPricePerWorker: data.workersRangeExtraPricePerWorker ?? data.workers_range_extra_price_per_worker ?? null,
                    workersRangePrices: data.workersRangePrices ?? data.workers_range_prices ?? [],
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching products:', error);
        }
    }, []);

    const getFoundProductsList = () => {
        return data;
    };

    return { findProducts, getFoundProductsList };
}
